import { EFormFieldTypes, TEntitySection } from '@/interfaces'
import RenderFormField from '../../fields'
import EntityFiles from '../files'
import { useMemo } from 'react'

export default function RenderSimpleSection({
  entitySection,
}: {
  entitySection?: TEntitySection
}) {
  const entitySectionFields = useMemo(
    () => entitySection?.fields ?? [],
    [entitySection]
  )

  if (entitySection) {
    const fileFields =
      entitySectionFields?.filter(
        (item) => item.type === EFormFieldTypes.UPLOAD_FILE
      ) ?? []

    const commonFields = entitySectionFields?.filter(
      (item) => item.type !== EFormFieldTypes.UPLOAD_FILE
    )

    return (
      <div className='section-content'>
        <EntityFiles fileFields={fileFields} />
        {commonFields?.map((fieldInfo, idx) => (
          <RenderFormField
            key={fieldInfo.name}
            fieldInfo={fieldInfo}
            index={idx + 1}
          />
        ))}
      </div>
    )
  }

  return null
}
